import React from 'react'
import './column.css'

class Column extends React.PureComponent {

  render() {
    const { children, ...props } = this.props
    const cs = [
      'col',
      props.span && `xsCol${props.span}`,
      props.smSpan && `smCol${props.smSpan}`,
      props.mdSpan && `mdCol${props.mdSpan}`,
      props.lgSpan && `lgCol${props.lgSpan}`
    ]
    return (
      <div className={cs.join(' ')}>{children}</div>
    )
  }
}
export default Column



// WEBPACK FOOTER //
// ./src/core/components/column/Column.js